import { Outlet } from 'react-router-dom'

const Notification = () => <Outlet />

export default Notification
